import React, { useEffect } from "react";
import axios from "axios";
import buildVersion from "app/buildVersion";

export default function C1FrontendVersionCheck() {
    useEffect(() => {
        const checkVersion = () => {
            axios.get("/version.json", {
                params: { t: Date.now() },
                headers: {
                    "Cache-Control": "no-cache"
                }
            }).then(response => {
                const serverVersion = response && response.data ? response.data.version : null;

                if (!serverVersion) {
                    return;
                }

                if (buildVersion !== serverVersion) {
                    window.location.reload();
                }
            }).catch(() => {
                // Do nothing if the version check temporarily fails.
            });
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                checkVersion();
            }
        };

        checkVersion();
        window.addEventListener("focus", checkVersion);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener("focus", checkVersion);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    return null;
}